export default __webpack_public_path__ + "static/media/ankara06.1a5db8b7.jpg";